import api from "@/api/v1-jwt/config/api";

export const sendNerRequest = async (text) => {
  const clientCognitoId = JSON.parse(localStorage.getItem("PLATFORM_ID"));
  if (!clientCognitoId) {
    throw new Error("It was not possible to identify the platform.");
  }

  const { data } = await api.post(`/ai/ner`, {
    text,
    // text: "write me a contract for Jeff selling 40 pounds of steel",
    cognito_id: clientCognitoId,
  });

  return data;
};

export const getAllContracts = async ({ query, userId }) => {
  if (!userId) {
    throw new Error("[FETCH_CONTACTS] User ID missing.");
  }

  let queryParams;
  if (query) {
    queryParams = Object.entries(query)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");
  }

  const url = queryParams
    ? `/platform/contracts/${userId}?${queryParams}`
    : `/platform/contracts/${userId}`;

  try {
    const { data } = await api.get(url);
    return data;
  } catch (error) {
    console.log(error);
    return error.response?.data;
  }
};

export const getContractsByContactId = async ({ userId, contactId }) => {
  if (!userId) {
    throw new Error("[GET_CONTRACTS_BY_CONTACT_ID] User ID missing.");
  }

  if (!contactId) {
    throw new Error("[GET_CONTRACTS_BY_CONTACT_ID] Contact ID missing.");
  }

  const { data } = await api.get(
    `/platform/contracts/${userId}/contact/${contactId}`
  );

  return data;
};

export const uploadUrl = async (params, file) => {
  const clientCognitoId = JSON.parse(localStorage.getItem("PLATFORM_ID"));
  if (!clientCognitoId) {
    throw new Error("It was not possible to identify the platform.");
  }

  try {
    // Get URL
    const { data: url } = await api.get(
      `/settings/upload_url/${clientCognitoId}?${params}`
    );

    // Upload New way
    const presignedData = url.uploadURLData;
    const formData = new FormData();
    Object.keys(presignedData.fields).forEach((key) => {
      formData.append(key, presignedData.fields[key]);
    });
    formData.append("file", file);
    const uploadResponse = await fetch(presignedData.url, {
      method: "POST",
      body: formData,
      redirect: "follow",
    });
    return { url: url, response: uploadResponse };
  } catch (err) {
    console.error(err);
  }
};

export const createContract = async ({ userId, payload }) => {
  if (!userId) {
    throw new Error("[CREATE_CONTRACT] User ID missing.");
  }

  if (!payload) {
    throw new Error("[CREATE_CONTRACT] Payload missing.");
  }

  const { data } = await api.post(`/platform/contracts/${userId}`, payload);
  return data;
};

export const getContractById = async ({ userId, contractId }) => {
  if (!userId) {
    throw new Error("[GET_CONTRACTS_BY_CONTRACT_ID] User ID missing.");
  }

  if (!contractId) {
    throw new Error("[GET_CONTRACTS_BY_CONTRACT_ID] Contract ID missing.");
  }

  const { data } = await api.get(`/platform/contracts/${userId}/${contractId}`);

  return data;
};

export const downloadContract = async ({ userId, payload }) => {
  if (!userId) {
    throw new Error("[DOWNLOAD_CONTRACT] User ID missing.");
  }

  if (!payload) {
    throw new Error("[DOWNLOAD_CONTRACT] Payload missing.");
  }

  const { data } = await api.post(`/settings/download_url/${userId}`, payload);

  return data;
};

export const deleteContract = async ({ userId, contractId }) => {
  if (!userId) {
    throw new Error("[DELETE_CONTRACT] User ID missing.");
  }

  if (!contractId) {
    throw new Error("[DELETE_CONTRACT] Contract ID missing.");
  }

  const { data } = await api.delete(
    `/platform/contracts/${userId}/${contractId}`
  );

  return data;
};

export const sendContractEmail = async ({ userId, contractId }) => {
  if (!userId) {
    throw new Error("[SEND_CONTRACT_EMAIL] User ID missing.");
  }

  if (!contractId) {
    throw new Error("[SEND_CONTRACT_EMAIL] Contract ID missing.");
  }

  const { data } = await api.post(
    `/platform/contracts/${userId}/send_email/${contractId}`,
    {}
  );

  return data;
};

export const createSmartContract = async (
  userId,
  contractText,
  invoiceId = null,
  contact,
  isQuote = false,
  quoteItems = null,
  expirationDate,
  // selectedOption,
  uploadedDate = new Date()
) => {
  const payload = {
    contact_id: contact.contact_id,
    uploaded_date: uploadedDate,
    contact: contact,
    invoice_id: invoiceId,
    contract_text: contractText,
    is_smart_contract: true,
    is_quote: isQuote,
    quote_items: quoteItems,
    expiration_date: new Date(expirationDate),
    delivery_option: "none",
    contract_status: "pending approval",
  };

  const { data } = await api.post(
    `/platform/contracts/${userId}/smart_contract`,
    payload
  );

  return data;
};

export const changeContractStatus = async ({
  clientId,
  contractId,
  contractStatus,
  deliveryOption,
}) => {
  if (!clientId) {
    throw new Error("[CHANGE_CONTRACT_STATUS] Client ID missing.");
  }

  if (!contractId) {
    throw new Error("[CHANGE_CONTRACT_STATUS] Contract ID missing.");
  }

  if (!contractStatus) {
    throw new Error("[CHANGE_CONTRACT_STATUS] Contract status missing.");
  }

  const payload = {
    contract_status: contractStatus,
    platform_id: clientId,
    contract_id: contractId,
  };

  // Add delivery_option to payload if it's not undefined
  if (deliveryOption !== undefined) {
    payload.delivery_option = deliveryOption;
  }

  const { data } = await api.patch(
    `/platform/contracts/customer/status`,
    payload
  );

  return data;
};

export const getQuoteOrContract = async ({ userId, contractText }) => {
  if (!userId) {
    throw new Error("[GET_QUOTE_OR_CONTRACT] User ID missing.");
  }

  if (!contractText) {
    throw new Error("[GET_QUOTE_OR_CONTRACT] Text missing.");
  }

  const { data } = await api.post(
    `/platform/contracts/quote_or_contract/${userId}`,
    {
      text: contractText,
    }
  );
  return data;
};

export const getLineItemsFromPrompt = async ({ userId, contractText }) => {
  if (!userId) {
    throw new Error("[GET_LINE_ITEMS_FROM_PROMPT] User ID missing.");
  }

  if (!contractText) {
    throw new Error("[GET_LINE_ITEMS_FROM_PROMPT] Text missing.");
  }

  const res = await api.post(
    `/platform/contracts/quote_items_from_prompt/${userId}`,
    {
      text: contractText,
    }
  );

  return res;
};
